import request from '@/utils/request';
//会员列表
export function getMemberList(param) {
  return request('/decision/model', {
    method: 'GET',
    params: param,
  });
}

//新增会员列表
export function addMember(values) {
  return request('/decision/model', {
    method: 'POST',
    data: values,
  });
}

//编辑会员列表
export function editMember(modelId, values) {
  return request(`/decision/model/${modelId}`, {
    method: 'PUT',
    data: values,
  });
}

// 删除接口
export function deleteModel(modelId) {
  return request(`/decision/model/${modelId}`, {
    method: 'DELETE',
  });
}

// 导出接口
export function exportModel(modelId) {
  return request(`/decision/model/export/${modelId}`, {
    method: 'GET',
    // responseType: 'arraybuffer',
  });
}

// 操作记录页面获取接口
export function getLog(modelId) {
  return request(`/decision/model/operatorLog/${modelId}`, {
    method: 'GET',
  });
}

// 模型名称页面获取接口
export function getModalNameTable(param) {
  return request('/decision/model/model-field', {
    method: 'GET',
    params: param,
  });
}

// 模型名称页面字段包删除接口
export function deleteModalField(modelId, params) {
  return request(`/decision/model/model-field/${modelId}`, {
    method: 'DELETE',
    params: params,
  });
}

// 快捷字段管理新增多选框获取接口
export function getAllField() {
  return request('/decision/field/field-package/all', {
    method: 'GET',
  });
}

/**
 * 字段 Api,获取该字段下table
 */
export function getQueryField(param) {
  return request('/decision/field', {
    method: 'GET',
    params: param,
  });
}

// 字段新增完成
export function addModelField(values) {
  return request('/decision/model/model-field', {
    method: 'POST',
    data: values,
  });
}

// 批量粘贴规则数据
export function pasteRule(values) {
  return request('/decision/model/model-field/paste', {
    method: 'POST',
    data: values,
  });
}

// 导入文件
export function uploadFile(values) {
  return request('/decision/model/import', {
    method: 'POST',
    data: values,
  });
}
